import axios from "@/plugins/axios";

let url = "/api/v1/me/files";

export default {
    gets(data) {
        return axios.get(url.interpolate(data), data).then((result) => result.data);
    },
    get(data) {
        return axios.get(`${url.interpolate(data)}/${data._id}`).then((result) => result.data);
    },
    post({ type, index }, file) {
        var headers = { "Content-Type": "multipart/form-data" };
        var formData = new FormData();
        if (![null, undefined].includes(type)) formData.append("type", type);
        if (![null, undefined].includes(index)) formData.append("index", index);
        formData.append("file", file);
        return axios.post(`${url.interpolate({ type })}`, formData, { headers }).then((result) => result.data);
    },
    put(data) {
        return axios.put(`${url.interpolate(data)}/${data._id}`, data).then((result) => result.data);
    },
    delete(data) {
        return axios.delete(`${url.interpolate(data)}/${data._id}`).then((result) => result.data);
    },
};
